export const PRICE_QUOTES_API_URL = 'ui/organization/price_quotes';
